(() => {
  const countdownSelector = '[data-video-banner-countdown]';
  const activeTimers = new WeakMap();

  const clearTimer = (countdown) => {
    const timer = activeTimers.get(countdown);
    if (timer) window.clearInterval(timer);
    activeTimers.delete(countdown);
  };

  const parseEndTime = (value) => {
    if (typeof value !== 'string') return Number.NaN;

    const normalizedValue = value.trim();
    if (!normalizedValue) return Number.NaN;

    return Date.parse(normalizedValue);
  };

  const padTime = (value) => String(value).padStart(2, '0');

  const updateCountdown = (countdown) => {
    const output = countdown.querySelector('[data-countdown-value]');
    const endTime = parseEndTime(countdown.dataset.end);

    if (!output || !Number.isFinite(endTime)) {
      if (output) {
        output.textContent = window.Shopify?.designMode ? 'FECHA NO VÁLIDA' : '-- : -- : --';
      }
      countdown.dataset.countdownState = 'invalid';
      clearTimer(countdown);
      return;
    }

    const remaining = Math.max(0, endTime - Date.now());

    if (remaining === 0) {
      output.textContent = countdown.dataset.expired || '00 : 00 : 00';
      countdown.dataset.countdownState = 'expired';
      clearTimer(countdown);
      return;
    }

    const showDays = countdown.dataset.showDays === 'true';
    const totalSeconds = Math.floor(remaining / 1000);
    const days = Math.floor(totalSeconds / 86400);
    const hours = showDays
      ? Math.floor((totalSeconds % 86400) / 3600)
      : Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const timeParts = showDays ? [days, hours, minutes, seconds] : [hours, minutes, seconds];

    output.textContent = timeParts.map(padTime).join(' : ');
    countdown.dataset.countdownState = 'running';
  };

  const initializeCountdown = (countdown) => {
    clearTimer(countdown);
    updateCountdown(countdown);

    if (countdown.dataset.countdownState === 'running') {
      activeTimers.set(
        countdown,
        window.setInterval(() => updateCountdown(countdown), 1000)
      );
    }
  };

  const initializeWithin = (root = document) => {
    if (root instanceof Element && root.matches(countdownSelector)) {
      initializeCountdown(root);
    }

    root.querySelectorAll?.(countdownSelector).forEach(initializeCountdown);
  };

  const clearWithin = (root) => {
    if (root instanceof Element && root.matches(countdownSelector)) {
      clearTimer(root);
    }

    root.querySelectorAll?.(countdownSelector).forEach(clearTimer);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(), { once: true });
  } else {
    initializeWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => clearWithin(event.target));
})();